import { action } from "mobx";
import { message } from "antd";
import { Declarant } from "../models/Declarant";
import { Clear, IObjectMap } from "../interfaces/common";
import ee from "../services/EventEmitter";
import {
  DELETED_ENTITY,
  FORCE_DELETE_DECLARANT_EVENT,
  RESTORE_DECLARANT_EVENT,
} from "../constants/events";
import AbstractLoaderStore from "./pages/AbstractLoaderStore";

const defaultParameters = {
  page: 0,
};

class DeletedStore extends AbstractLoaderStore implements Clear {
  constructor() {
    super();

    ee.on(DELETED_ENTITY, () => {
      this.load({}, true);
    });

    ee.on(FORCE_DELETE_DECLARANT_EVENT, (id: unknown) => {
      this.delete(id);
    });

    ee.on(RESTORE_DECLARANT_EVENT, (id: unknown) => {
      this.restore(id);
    });
  }

  getLoadResponse(parameters: IObjectMap): Promise<Response> {
    return this.apiManager.loadDeletedEntities(parameters);
  }

  @action
  restore(id: unknown): void {
    this.apiManager
      .restoreDeclarant(id)
      .then(async (response) => {
        if (response.ok) {
          const data = await response.json();
          this._data = this.data.filter(
            (item) => (item as Declarant).id !== id
          );

          message.success(data.message);
        }
      })
      .catch(async (response) => {
        const data = await response.json();
        message.error(data.message);
      });
  }

  @action
  delete(id: unknown): void {
    this.apiManager
      .forceDeleteDeclarant(id)
      .then(async (response) => {
        if (response.ok) {
          const data = await response.json();
          this._data = this.data.filter(
            (item) => (item as Declarant).id !== id
          );

          message.success(data.message);
        }
      })
      .catch(async (response) => {
        const data = await response.json();
        message.error(data.message);
      });
  }

  @action
  clear(): void {
    this.apiManager
      .clearDeclarants()
      .then(async (response) => {
        const data = await response.json();

        if (response.ok) {
          this.reset();
          this.load({}, true);

          message.success(data.message);
        }

        return response;
      })
      .catch(async (response) => {
        const data = await response.json();

        message.error(data.message);
      });
  }

  private reset() {
    this._data = [];
    this._parameters = defaultParameters;
  }
}

export default DeletedStore;
